<template>
  <div class="priceScreening">
    <Form @submitSuccess="getList" ref="form"/>
    <div class="groupButton">
      <AppButton customType="default" @click="addMenu">添加价格</AppButton>
    </div>
    <BasicTable
      hiddenFooter
      :tableData="tableData"
      :columns="columns" 
      :node="node"
      @treeID="getNode">
      <template v-slot:is_enable="{ item }">
        <CheckBox v-model="item.is_enable" @change="enablePrice(item)" ></CheckBox>
      </template>
      <template v-slot:add_time="{ item }">
        {{item.add_time*1000 | dateFormat('YYYY-MM-DD') }}
      </template>
      <template v-slot:operate="{ item }">
        <AppButton type="primary" plain size="small" @click="editMenu(item)"><i class="fa fa-edit fa-lg icon" ></i>编辑</AppButton>
        <AppButton type="primary" plain size="small" @click="deleteMenu(item)"><i class="fa fa-trash-o fa-lg icon"></i>删除</AppButton>
      </template>
    </BasicTable>
  </div>
</template>

<script>
import { MessageBox } from 'element-ui';
import { WebsiteService } from '../../service/website.service'
import Form from './formPrice';
const columns = [
  { name: '价格', key: 'name' },
  { name: '是否启用', key: 'is_enable', type: 'custom'},
  { name: '添加时间', key: 'add_time', type: 'custom'},
  { name: '操作', key: 'operate', type: 'custom'}
];
  export default {
    name: 'price',
    components: { Form },
    data() {
      return {
        fields: [],
        tableData: [],
        columns,
        node: []
      }
    },
    created() {
      this.getList();
    },
    methods: {
      async getList() {
        const data = await WebsiteService.getPrice();
        this.tableData = data;
      },
      addMenu() {
        this.$refs.form.open('add',{});
      },
      editMenu(data) {
        this.$refs.form.open('edit', data);
      },
      deleteMenu(data) {
        MessageBox.confirm('确定要删除这条价格吗？', '删除价格').then(async () => {
          await WebsiteService.delScreening_price(data.id)
          this.getList();
        })
      },
      filter() {
        this.getList();
      },
      async getNode(id) {
          const data = await WebsiteService.getNodeSon(id)
          this.node = data
      },
      enablePrice(item) {
          WebsiteService.swichScreening_priceStatus(item.id, item.is_enable ? 1 : 0);
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon {
  font-size: 1vw;
}
</style>